const imagem = {
  //logo : require('../images/Saae7lagoas.png')
  //logo: require('../images/logo-tocantins.png'),
  //logo: require('../images/logo-bras-pires.png'),
  logo: require('../images/logo-itabira.png'),
};

export default imagem;
